<template>
  <div class="d-flex justify-space-between align-baseline">
    <gli-text-field
      class="px-1"
      type="number"
      v-model="range.from"
      clearable
      :label="fromLabel"
      :step="stepValue"
      :min="0"
    ></gli-text-field>
    <span class="mx-1">-</span>
    <gli-text-field
      class="px-1"
      type="number"
      v-model="range.to"
      clearable
      :label="toLabel"
      :step="stepValue"
      :min="0"
    ></gli-text-field>
  </div>
</template>

<script>
export default {
  name: 'NumberRangeField',
  data: function () {
    return {
      range: { from: null, to: null }
    };
  },
  props: {
    value: Object,
    fromLabel: String,
    toLabel: String,
    stepValue: Number
  },
  mounted() {
    this.range = this.value;
  },
  watch: {
    'range.from': {
      handler(newVal) {
        if (newVal === 0) {
          this.value.from = null;
        }
      }
    },
    'range.to': {
      handler(newVal) {
        if (newVal === 0) {
          this.value.to = null;
        }
      }
    }
  }
};
</script>
